import {AbstractControl} from "@angular/forms";
import {Component, Input, ViewChild} from "@angular/core";
import {NameDataInfoDto} from "../../../models/student-ticket/list-view/NameDataInfoDto";
import {AbstractFormModalComponent} from "../../../shared/modal/abstract-form-modal.component";
import {ModalShellComponent} from "../../../shared/modal/modal-shell/modal-shell.component";
import {NameDetailsFormComponent} from "../../../shared/name-details-form/name-details-form.component";

@Component({
  selector: 'app-name-details-adjust-modal',
  templateUrl: './name-details-adjust-modal.component.html',
  styleUrls: ['./name-details-adjust-modal.component.scss'],
  imports: [
    ModalShellComponent,
    NameDetailsFormComponent
  ],
  standalone: true
})
export class NameDetailsAdjustModalComponent extends AbstractFormModalComponent {

  @Input() nameDetails: NameDataInfoDto;

  protected validationErrorKey = 'NAME_DATA.VALIDATION_ERROR';

  @ViewChild(NameDetailsFormComponent) private nameForm: NameDetailsFormComponent;

  protected get form(): AbstractControl {
    return this.nameForm?.form;
  }

  protected getCloseValue(): unknown {
    return this.nameForm.getFormValue();
  }
}
